module.exports = __webpack_public_path__ + "img/raspberry-jam.b22c7e04.png";